import Aos from "aos";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Courses from "./Data.json";
import "./schedule.scss";
function Schedule() {
  useEffect(() => {
    // document.title = "Gemological Education Schedule | Galaxy Gemological Institute";
    window.scrollTo(0, 0);
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div className="schedule">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/gemological-education/schedule"
        />
        <title>
          Gemological Education Schedule | Galaxy Gemological Institute
        </title>
        <meta
          name="description"
          content="Our programs are taught by experienced gemologists and cover all aspects of gemology, from the identification of gemstones to the grading of diamonds. Contact us now!"
        />
      </Helmet>
      <div className="container scheduleCon">
        <div className="coursesTimeDiv">
          <div className="titleDiv">
            <h1 className="title" data-aos="zoom-in-up">
              Courses We're Offering
            </h1>
            <div class="customAccordion" data-aos="zoom-in">
              {Courses.map((cor, i) => {
                return (
                  <div class="accordionItem">
                    <h2 class=" accordionHeader" id="headingOne">
                      <button
                        class="accordionButton"
                        type="button"
                        data-aos="flip-right"
                      >
                        {cor.Course}
                      </button>
                    </h2>
                    <div id={i} class=" accordionCollapse  ">
                      <div class="accordionBody">
                        <div style={{ overflowX: "auto" }}>
                          <table className="courseDetTable">
                            <thead>
                              <tr data-aos="flip-left">
                                <th data-aos="fade-right">Course</th>
                                <th data-aos="fade-right">Duration</th>
                                <th data-aos="fade-right">Session</th>
                                <th data-aos="fade-right">ClassPerWeek</th>
                                <th data-aos="fade-right">Timings</th>
                                <th data-aos="fade-right">Fees</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr data-aos="flip-left">
                                <td data-aos="fade-down">{cor.Course}</td>
                                <td data-aos="fade-down">{cor.Duration}</td>
                                <td data-aos="fade-down">{cor.Session}</td>
                                <td data-aos="fade-down">{cor.ClassPerWeek}</td>
                                <td data-aos="fade-down">{cor.Timings}</td>
                                <td data-aos="fade-down">{cor.Fees}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* <div style={{ overflowX: "auto" }}>
													<table className="courseDateTable">
														<thead>
															<tr data-aos="flip-left">
																<th data-aos="fade-right">Start Date</th>
																<th data-aos="fade-right">End Date</th>
																<th data-aos="fade-right">Timing (Morning)</th>
																<th data-aos="fade-right">Timing (Evening)</th>
															</tr>
														</thead>
														<tbody>
															<tr data-aos="flip-left">
																<td data-aos="fade-down">20 sept 2019</td>
																<td data-aos="fade-down">30 dec 2019</td>
																<td data-aos="fade-down">09:00 am</td>
																<td data-aos="fade-down">04:00 pm</td>
															</tr>
														</tbody>
													</table>
												</div> */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
